<template>
	<li ref="item">
		<router-link
			v-if="!!node.route"
			custom
			:to="tenantRoute(node.route)"
  			v-slot="{ href, navigate, isExactActive }"
			>
			<a :href="href"
				v-bind="itemAttr"
				@click.prevent="doClickEvent($event, navigate)"
				:class="[
					linkClass,
					'submenu-'+(showChildMenu ? 'show' : 'hidden'),
					{ 'has-children' : hasChildren, 'active' : isExactActive }
				]"
				>
				<slot></slot>
				<i v-if="hasChildren" ref="caret" class="nav-caret fas"
					:class="'fa-caret-'+(!showChildMenu ? 'down' : 'up')"
					@click.stop.prevent="showChildMenu = !showChildMenu">
				</i>
			</a>
		</router-link>

		<a v-else
			v-bind="itemAttr"
			:href="(node.href || '#')"
			@click.prevent="doClickEvent($event)"
			:class="[linkClass,'submenu-'+(showChildMenu ? 'show' : 'hidden'),{ 'has-children' : hasChildren }]"
			>
			<slot></slot>
			<i v-if="hasChildren" ref="caret" class="nav-caret fas" :class="'fa-caret-'+(!showChildMenu ? 'down' : 'up')" @click.stop.prevent="showChildMenu = !showChildMenu"></i>
		</a>

		<main-nav
			v-if="hasChildren"
			v-show="(showChildMenu || showSubmenuForce)"
			:tree="node.children"
			class="submenu"
		/>

	</li>
</template>

<script>
import { eventBus } from '@/busses/EventBus';
import { mapState } from 'vuex';

export default {
	data: () => ({
		showChildMenu: false,
	}),
	props: {
		node: {
			type: Object,
			default: {},
		},
		linkClass: {
			type: String,
			default: 'nav-link',
		},
		showSubmenuForce: {
			type: Boolean,
			default: false,
		}
	},

	// TODO: This only works if no game is loaded
	// Need to detect when a game is loaded, then call submenuHasCurrent again
	created(){
		this.showChildMenu = this.submenuHasCurrent
	},
	computed: {
		...mapState({
			_TENANT: (state) => state.tenant,
		}),
		blockedApps() {
			return this.tenant.blocked_apps.length ? this.tenant.blocked_apps.concat(['settingsIntegrations']) : [];
		},
		submenuHasCurrent() {
			return (this.node.route == this._NAV.currentRoute() || !!this.node.children.find(r => r.route == this._NAV.currentRoute()));
		},
		hasChildren() {
			return (this.node.children && this.node.children.length);
		},
		itemAttr(){
			let attr = {}
			attr.class = [this.node.class, { disabled: this.node.disabled }]
			if(this.node.id) { attr.id = this.node.id }
			return attr
		}
	},
	methods : {
		doClickEvent($event, navigate) {
			if (this.tenant.limited_access && this.blockedApps.includes(this.node.route)) {
				eventBus.grandchildData = `${this.node.route}~${Math.random()}`;
				return;
			}

			if (this.node.id !== 'hs-crm-in-nav') {
				navigate();
			}

			if(this.hasChildren) {
				if(!this.showChildMenu && this.$refs.caret != $event.target) {
					this.showChildMenu = true
				}
			}
			if(this.node.click) {this.node.click()}
		}
	}
};
</script>